<template>
  <div>
    <div :class="pc ? 'inner' : 'moinner'">
        <p :class="pc ? 'title' : 'motitle'">{{ $t('notFound.title') }}</p>
        <p :class="pc ? 'text' : 'motext'">{{ $t('notFound.text') }}</p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  data () {
    return {
     locale:"",
     pcHeight:"",
     footerHeight:"",
     innerHeight:"",
     rot:"",
    }
  },
  methods: {
  },
  mounted () {
     if (this.pc) {
      window.resetLayout()
      this.footerHeight=document.getElementsByClassName("inner")[0].offsetHeight
      this.innerHeight=document.getElementsByClassName("footer")[0].offsetHeight-10
      this.pcHeight=this.footerHeight+this.innerHeight
      // document.getElementById("innerWidths").style.height=this.pcHeight.toString()+"px"
      
      console.log(document.body.offsetWidth)
      if(document.body.offsetWidth>=1200){
        document.getElementsByClassName("desktop")[0].style.height=this.pcHeight.toString()+"px"
      }else if(document.body.offsetWidth>780 && document.body.offsetWidth<1200){
        document.getElementsByClassName("tablet")[0].style.height=this.pcHeight.toString()+"px"
      }
      
    }
    
    
  },
  created () {
    this.locale = localStorage.languageSet
  },
}
</script>
<style scoped>
.title{
    margin: 55px auto;
    font-size: 55px;
    line-height: 55px;
    text-align: center;
    font-weight: 600;
    /* position: relative;
    top: 50%;
    transform: translateY(-50%); */
}
.text{
    margin: 15px auto;
    text-align: center;
    font-size:15px;
    margin:0 auto;
    /* position: relative;
    top: 50%;
    transform: translateY(-50%); */
}
.inner{
   margin: 0px 0 180px;
   /* height: 600px; */
   padding-top:8rem;
   /* position: absolute; */
}
.moinner{
   margin: 125px 25px 80px;
}
.motitle{
    margin:0  auto 50px;
    font-size: 32px;
    line-height: 35px;
    text-align: center;
    font-weight: 600;
}
.motext{
 text-align: center;
    font-size:12px;
    margin:0 auto;
}
</style>
